import { CHATWOOT_RESET, CHATWOOT_SET_USER } from '../constants/appEvents';
import SessionStorage from 'shared/helpers/sessionStorage';
import { emitter } from 'shared/helpers/mitt';
import { SESSION_STORAGE_KEYS } from 'dashboard/constants/wgptSessionStorage';

// The SDK defines window.$whatsgpt before the widget app has booted, so the
// object alone is not a ready signal: a setUser sent in that window is lost.
// Wait for the loaded handshake (hasLoaded), which whatsgpt:ready announces.
const whatsGPTReady = () => {
  return new Promise(resolve => {
    if (window.$whatsgpt?.hasLoaded) {
      resolve();
      return;
    }

    window.addEventListener(
      'whatsgpt:ready',
      () => {
        resolve();
      },
      {
        once: true,
      }
    );
  });
};

export const initializeWhatsGPTEvents = () => {
  emitter.on(CHATWOOT_RESET, async () => {
    await whatsGPTReady();
    if (window.$whatsgpt) {
      window.$whatsgpt.reset();
    }
  });
  emitter.on(CHATWOOT_SET_USER, async ({ user }) => {
    await whatsGPTReady();
    if (window.$whatsgpt) {
      window.$whatsgpt.setUser(user.email, {
        avatar_url: user.avatar_url,
        email: user.email,
        identifier_hash: user.hmac_identifier,
        name: user.name,
        company_name: user.accounts.find(
          account => account.id === user.account_id
        )?.name,
      });
      window.$whatsgpt.setCustomAttributes({
        signedUpAt: user.created_at,
        cloudCustomer: 'true',
        account_id: user.account_id,
      });
      if (SessionStorage.get(SESSION_STORAGE_KEYS.WIDGET_OPEN_ON_LOAD)) {
        SessionStorage.remove(SESSION_STORAGE_KEYS.WIDGET_OPEN_ON_LOAD);
        window.$whatsgpt.toggle();
      }
    }
  });
};
